export default __webpack_public_path__ + "static/media/toledo_6.eca2fe8e.png";